import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import MaterialTable from "material-table";
import {
  showNotification,
  withDataProvider,
  Loading,
  GET_MANY,
  GET_LIST
} from "react-admin";
import { DELETE } from "ra-core";
import Dialog from "../../components/dialog/Dialog";
import LoadingIndicator from "../../components/loadingIndicator";
import { formatNumber } from "../../utils/formating";

const styles = {
  detail: {
    root: {
      width: "80%",
      float: "right"
    },
    row: {
      backgroundColor: "rgb(239, 237, 237)"
    }
  }
};

const cantidadTotal = items => {
  const val = items
    .map(({ quantity }) => quantity)
    .reduce((sum, i) => sum + i, 0);

  return formatNumber(val);
};

const ExpandPanel = ({ record, key }) => {
  return (
    <div style={styles.detail.root} key={key}>
      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left">ID</TableCell>
              <TableCell align="left">Código</TableCell>
              <TableCell align="left">Descripción</TableCell>
              <TableCell align="left">Cantidad</TableCell>
              <TableCell align="left"> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {record.map((row, key) =>
              <TableRow key={key}>
                <TableCell align="left">
                  {row.productId}
                </TableCell>
                <TableCell align="left">
                  {row.code}
                </TableCell>
                <TableCell align="left">
                  {row.description}
                </TableCell>
                <TableCell align="left">
                {formatNumber(row.quantity)}
                </TableCell>
              </TableRow>
            )}

            <TableRow>
              <TableCell rowSpan={2} />
              <TableCell rowSpan={2} />
              <TableCell rowSpan={2} style={styles.detail.row}>
                Total Unidades
              </TableCell>
              <TableCell rowSpan={2} align="left" style={styles.detail.row}>
                {cantidadTotal(record)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
};

class Orders extends Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = {
      loadingListOrders: false,
      dataOrders: null,
      openDialogDelete: false,
      rowDataToDelete: null,
      deleteOrdenProgress: false
    };
  }

  static propTypes = {
    RUT: PropTypes.string,
    customer: PropTypes.object
  };

  componentDidMount() {
    const { customer } = this.props;
    if (customer.customerId) {
      this.getData(customer.customerId);
    } else {
      window.location.href = window.location.origin + "/#/";
    }
  }

  openCloseDialog = rowData => {
    this.setState(state => {
      return {
        openDialogDelete: !state.openDialogDelete,
        rowDataToDelete: rowData
      };
    });
  };

  deleteOrden = () => {
    const { dataProvider, dispatch } = this.props;
    const { rowDataToDelete } = this.state;
    if (rowDataToDelete) {
      this.setState(state => {
        return {
          openDialogDelete: !state.openDialogDelete,
          deleteOrdenProgress: true
        };
      });
      dataProvider(DELETE, "orders/delete/", { id: rowDataToDelete.id })
        .then(({ data }) => {
          const { errorNumber } = data;
          this.setState({ deleteOrdenProgress: false });
          if (!errorNumber) {
            const { dataOrders } = this.state;
            //filtra la orden de la lista de ordenes del stado
            const dataOrdersUpdated = dataOrders.filter(
              ord => ord.id !== rowDataToDelete.id
            );
            this.setState({ dataOrders: dataOrdersUpdated });
          } else {
            dispatch(showNotification("Error al borrar la orden", "error"));
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  getData = customerId => {
    const { dataProvider, dispatch } = this.props;

    dataProvider(GET_LIST, `orders/get/list?customerId=${customerId}`, null)
      .then(({ data }) => {
        let ids = [];
        data.forEach(order => {
          ids.push(order.orderNumber);
        });
        dataProvider(GET_MANY, "orders/get", { ids })
          .then(data => {
            this.setState({ loadingListOrders: true, dataOrders: data.data });
          })
          .catch(error => {
            console.error(error);
          });
      })
      .catch(error => {
        dispatch(showNotification(error.message, "error"));
      });
  };

  getorders = query => {
    const { dataOrders } = this.state;
    query.data = dataOrders;
    return query;
  };

  render() {
    const {
      loadingListOrders,
      dataOrders,
      openDialogDelete,
      rowDataToDelete,
      deleteOrdenProgress
    } = this.state;
    const { customer } = this.props;
    return loadingListOrders
      ? <div>
          <MaterialTable
            tableRef={this.tableRef}
            options={{
              search: true
            }}
            columns={[
              { title: "Id", field: "id", defaultSort: "desc" },
              { title: "Vendedor", field: "salesmenName" },
              { title: "Cliente", field: "customerName" },
              { title: "Emisión", field: "emision" },
              {
                title: "Total Unidades",
                field: "emision",
                render: rowData => cantidadTotal(rowData.detailLines)
              }
            ]}
            data={dataOrders}
            title={`Ordenes para el cliente: ${customer.customer}`}
            detailPanel={rowData => {
              return (
                <div key={rowData.id}>
                  <ExpandPanel record={rowData.detailLines} />
                </div>
              );
            }}
            actions={[
              {
                icon: "add",
                tooltip: "Crear Orden",
                isFreeAction: true,
                onClick: event =>
                  (window.location.href =
                    window.location.origin + "/#/orders/create")
              },
              {
                icon: "edit",
                tooltip: "Editar Orden",
                onClick: (event, rowData) => {
                  window.location.href =
                    window.location.origin + `/#/ordersEdit/${rowData.id}`;
                }
              },
              {
                icon: "delete",
                tooltip: "Borrar Orden",
                onClick: (event, rowData) => {
                  this.openCloseDialog(rowData);
                }
              }
            ]}
          />
          {rowDataToDelete &&
            <Dialog
              isWarningOpen={openDialogDelete}
              onClickCloseWarning={this.openCloseDialog}
              onClickConfirmWarning={this.deleteOrden}
              title={"Borrar Orden"}
              body={`Se borrará la orden con id: ${rowDataToDelete.id}, Desea Continuar? `}
              warningButtonConfirm={"Borrar"}
            />}
          {deleteOrdenProgress &&
            <LoadingIndicator
              isLoading={deleteOrdenProgress}
              isFullScreen={true}
              text={"Borrando Orden"}
            />}
        </div>
      : <Loading />;
  }
}

Orders.propTypes = {
  dataProvider: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default withStyles(styles)(withDataProvider(Orders));
